export function isCbsOrder(order) {
  var _order$tenantStoreSet, _order$tenantStoreSet2;
  return Boolean((_order$tenantStoreSet = order.tenantStoreSettings) === null || _order$tenantStoreSet === void 0 ? void 0 : (_order$tenantStoreSet2 = _order$tenantStoreSet.curatedBrandStore) === null || _order$tenantStoreSet2 === void 0 ? void 0 : _order$tenantStoreSet2.parentId);
}